import React from 'react';
import { Button } from '@thd-olt-component-react/core-ui';
import CheckIcon from '@material-ui/icons/Check';
import { useStore } from '../../../../store';
import { clickEvents } from '../../../../utils/analytics';

const InviteCandidateButton = ({ allowInvite, candidateId }) => {

  const {
    recommendedCandidatesStore: { inviteCandidateToJobPosting },
    jobPostingStore: { activeJobPosting }
  } = useStore();

  const handleInviteCandidateToJobPosting = () => {
    clickEvents.recommendationsTabActionsClick('invite');
    inviteCandidateToJobPosting(activeJobPosting.jobPostingId, candidateId);
  };

  if (allowInvite) {
    return (
      <div className="ptp-recommended-page__invite-button-container">
        <Button
          className="ptp-recommended-page__invite-button"
          data-testid="invite-candidate-button"
          onClick={handleInviteCandidateToJobPosting}
        >
          Invite Candidate to Apply
        </Button>
      </div>
    );
  }
  return (
    <div className="ptp-recommended-page__invite-button-container">
      <Button
        className="ptp-recommended-page__invite-button"
        data-testid="invite-candidate-button"
        disabled
      >
        Invited to Apply
        <CheckIcon />
      </Button>
    </div>
  );
};

export default InviteCandidateButton;
